// extracted by mini-css-extract-plugin
export var passwordForm = "password-module--passwordForm--e8f28";